import { useMemo } from 'react';
export const useKey = (resource, params) => useMemo(() => {
  var _resource$identifyIns;
  return (_resource$identifyIns = resource === null || resource === void 0 ? void 0 : resource.identifyInstance(params)) !== null && _resource$identifyIns !== void 0 ? _resource$identifyIns : '';
}, [resource, params]);